export default {"src":"/_next/static/media/ic_verified_badge_medium.1ee221a7.svg","height":35,"width":36};